import { render, staticRenderFns } from "./TipTapViewer.vue?vue&type=template&id=4f687790&scoped=true"
import script from "./TipTapViewer.vue?vue&type=script&lang=js"
export * from "./TipTapViewer.vue?vue&type=script&lang=js"
import style0 from "./TipTapViewer.vue?vue&type=style&index=0&id=4f687790&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f687790",
  null
  
)

export default component.exports